import { IFetchResponse, AppLog } from "@preveil-api";
import { BaseAPI, isValidJSON } from "src/common";
import _ from "lodash";

//------------------------------------------------------------------------------
// Description: Fetch App level Configurations from "/" as base_url
//------------------------------------------------------------------------------
export const getAppConfiguration = (): Promise<IFetchResponse> => {
    return BaseAPI.get("/config", null, {
        responseType: "json"
    })
        .then((response: IFetchResponse) => {
            // NOTE: Validate end point response before passing it back. Fall back to empty and the saga will default to .env variables
            const valid = isValidJSON(_.isString(response.data) ? response.data : JSON.stringify(response.data));
            return valid ? response : { ...response, isError: true, data: null };
        });
}

// Description: Log to app-server errors or for debugging
export const postAppLog = async (data: AppLog): Promise<IFetchResponse> => {
    return await BaseAPI.put(`/post/log`, data);
}
